import { BasePageDto } from "@/types/dto/base-page-dto";
import { BaseResponse } from "@/types/dto/base-response";
import { AxiosInstance } from "axios";
import { DepartmentDto } from "../types/dto/department-dto";
import { GetAdminPagePayload } from "../types/payload/get-admin-page-payload";
import { UpdateDepartmentPayload } from "../types/payload/update-department-payload";
import { baseApi } from "./base-api";

enum DepartmentServiceEndpoint {
  CreateDepartment = "/department",
  UpdateDepartment = "/department",
  DeleteDepartment = "/department",
  GetDepartmentById = "/department",
  GetDepartmentPage = "/departments",
}

class DepartmentService {
  private static instance: DepartmentService;
  private _api: AxiosInstance;

  private constructor(api: AxiosInstance) {
    this._api = api;
  }

  static getInstance(apiClient = baseApi): DepartmentService {
    if (!DepartmentService.instance) {
      DepartmentService.instance = new DepartmentService(apiClient);
    }
    return DepartmentService.instance;
  }

  async updateById(
    id: number,
    payload: UpdateDepartmentPayload
  ): Promise<BaseResponse<void, UpdateDepartmentPayload>> {
    try {
      const response = await this._api.patch<
        BaseResponse<void, UpdateDepartmentPayload>
      >(`${DepartmentServiceEndpoint.UpdateDepartment}/${id}`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error updateById:", error);
      throw error;
    }
  }

  async create(
    payload: UpdateDepartmentPayload
  ): Promise<BaseResponse<DepartmentDto, UpdateDepartmentPayload>> {
    try {
      const response = await this._api.post<
        BaseResponse<DepartmentDto, UpdateDepartmentPayload>
      >(`${DepartmentServiceEndpoint.CreateDepartment}`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error create:", error);
      throw error;
    }
  }

  async getById(id: number): Promise<BaseResponse<DepartmentDto, void>> {
    try {
      const response = await this._api.get(
        `${DepartmentServiceEndpoint.GetDepartmentById}/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("Error getById:", error);
      throw error;
    }
  }

  async deleteById(id: number): Promise<BaseResponse<void, void>> {
    try {
      const response = await this._api.delete<BaseResponse<void, void>>(
        `${DepartmentServiceEndpoint.DeleteDepartment}/${id}`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleteById:", error);
      throw error;
    }
  }

  async getPage(
    payload: GetAdminPagePayload
  ): Promise<BaseResponse<BasePageDto<DepartmentDto>, GetAdminPagePayload>> {
    try {
      const response = await this._api.get<
        BaseResponse<BasePageDto<DepartmentDto>, GetAdminPagePayload>
      >(DepartmentServiceEndpoint.GetDepartmentPage, {
        params: {
          page: payload.page,
          size: payload.size,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error getPage:", error);
      throw error;
    }
  }
}

export const departmentService = DepartmentService.getInstance(baseApi);
